// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b3454860","59":"c900e5b2","236":"2d29aea6","604":"d78b35b7","633":"3d509e53","717":"d104b3eb","748":"14d83105","791":"9537deef","853":"084a0236","990":"a1d88e82"}[chunkId] + ".chunk.js";
};